module.exports = __webpack_public_path__ + "static/media/pastorrob.e4cf9e3d.jpg";